import * as Yup from 'yup'; 
import { AutocompleteValues, FieldTypes, IFields, InputModes } from 'models/Form/FieldsModels'
import { personalIdParser } from 'components/Form/Helpers/Parsers'
import { hasPersonalIdNumberCorrectFormat } from 'components/Form/Validations/PersonalIdNumberValidation'
import { isDateValid, isPersonalIdReleaseCorrect } from 'components/Form/Validations/DateValidation'



export enum CollectPersonalIdFieldsNames {
   PersonalId = 'PersonalId',
   PersonalIdRelease = 'PersonalIdRelease',
}

export const collectPersonalIdFields: IFields = {
   [CollectPersonalIdFieldsNames.PersonalId]: {
      order: 5,
      name: CollectPersonalIdFieldsNames.PersonalId,
      type: FieldTypes.string,
      label: "Numer Dowodu",
      placeholder: "Składa się z trzech liter i sześciu cyfr",
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.Off,
      fullWidthInput: true,

      visible: true,
      mask: 'aaa999999',
      parser: personalIdParser,
      validation: Yup.string().required("Niepoprawna wartość").test(hasPersonalIdNumberCorrectFormat)
   },
   [CollectPersonalIdFieldsNames.PersonalIdRelease]: {
      order: 10,
      name: CollectPersonalIdFieldsNames.PersonalIdRelease,
      type: FieldTypes.date,
      label: "Data wydania",
      placeholder: "Data wydania dowodu osobistego",
      inputMode: InputModes.numeric,
      browserAutocomplete: AutocompleteValues.Off,
      fullWidthInput: true,

      visible: true,
      validation: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isPersonalIdReleaseCorrect)
   },
}